import React, { Component, Fragment } from 'react'

import { Camera, Cross } from '../../components/Icons'
import { UploadContainer, ContentContainer, Image, Background, FlexContainer, Overlay, Label, Feedback } from './styles'

class Upload extends Component {
  constructor(props) {
    super(props)
    this.state = {
      valid: true
    }
  }

  fileChangedHandler(event) {
    let files = this.props.value ? this.props.value : []
    if (files.length + [...event.target.files].length < 3) {
      this.setState({ valid: true })
      ;[...event.target.files].forEach((file, index) => {
        files.push(file)
        if (event.target.files.length === files.length) {
          this.props.handleChange({
            target: {
              dataset: {
                key: this.props.dataKey
              },
              type: 'file',
              name: this.props.name,
              value: files
            }
          })
        }
      })
    } else {
      ;[...event.target.files].forEach((file, index) => {
        if (index < 2) {
          files.push(file)
          if (files.length === 2) {
            this.props.handleChange({
              target: {
                dataset: {
                  key: this.props.dataKey
                },
                type: 'file',
                name: this.props.name,
                value: files
              }
            })
          }
        }
      })
      this.setState({ valid: false })
    }
  }

  removeFile(e) {
    let files = this.props.value ? this.props.value : []
    files.splice(e.currentTarget.dataset.key, 1)
    this.props.handleChange({
      target: {
        dataset: {
          key: this.props.dataKey
        },
        type: 'file',
        name: this.props.name,
        value: files
      }
    })
  }

  render() {
    const { label, name } = this.props
    const files = this.props.value ? this.props.value : []
    return (
      <Fragment>
        <Label>{label}</Label>
        <FlexContainer>
          {files.map((file, index) => (
            <Image key={index}>
              <Background style={{ backgroundImage: `url(${window.URL.createObjectURL(file)})` }} />
              <Overlay data-key={index} onClick={this.removeFile.bind(this)}>
                <Cross />
              </Overlay>
            </Image>
          ))}
          {files.length < 2 ? (
            <UploadContainer>
              <ContentContainer>
                <div>
                  <Camera size="" />
                  <p>Foto uploaden</p>
                </div>
              </ContentContainer>
              <input
                type="file"
                accept="image/png,image/jpeg"
                name={name}
                onChange={this.fileChangedHandler.bind(this)}
                multiple
              />
            </UploadContainer>
          ) : null}
        </FlexContainer>
        <Feedback valid={this.state.valid}>Maximaal 2 afbeeldingen</Feedback>
      </Fragment>
    )
  }
}

export default Upload



// WEBPACK FOOTER //
// ./src/components/Upload/index.js